export const AUTO_CANCELLATION = 'AUTO_CANCELLATION';
export const CANCELLATION_REQUEST = 'CANCELLATION_REQUEST';
